/**
 * This component allows us to link to `id` on pages.
 *
 * Example: /some-page#some-component-id
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router';

const useAnchorLink = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const getTarget = () => {
        let target: Element | null = null;
        try {
          target = document.querySelector(hash);
        } catch (e) {
          // Can crash for invalid selectors
          console.warn(e);
        }
        return target;
      };

      const target = getTarget();

      /**
       * If in view, scroll to it.
       */
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' });

        /**
         * Add observer to scroll to it when in view. Component might be conditional renederd.
         */
      } else if (window.ResizeObserver) {
        const resizeObserver = new window.ResizeObserver(() => {
          const target = getTarget();
          if (target) {
            window.requestAnimationFrame(() => target.scrollIntoView({ behavior: 'smooth' }));
          }
        });
        resizeObserver.observe(document.body);
        return () => resizeObserver.disconnect();
      }
    }
    return;
  }, [hash]);
};

export default useAnchorLink;
